// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BoundOptionPricingConfigFields_OptionPricingConfigFragmentDoc } from '../components/BoundOptionPricingConfig.generated';
import { BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc } from '../components/BoundMaterialLeadTimeConfigFields.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemsPageMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ItemsPageMetadataQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string, version: number }> };

export type ItemsQueryVariables = Types.Exact<{
  filter: Types.ItemFilter;
}>;


export type ItemsQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, itemCode: number, name: string, isSelection: boolean, specifications?: string | null | undefined, materialCodePrefix?: string | null | undefined, costCode: { __typename?: 'CostCode', id: string, number: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, cutoff?: { __typename?: 'Cutoff', id: string, name: string } | null | undefined, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string }>, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }, takeoffType?: { __typename?: 'ItemTakeoffTypeDetail', code: Types.ItemTakeoffType, name: string } | null | undefined, optionPricingConfig?: { __typename?: 'OptionPricingConfig', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'OptionPricingConfigVariant', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents?: number | null | undefined, reasonNote?: string | null | undefined, projects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }> } | null | undefined, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined }>, unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string }> };

export type AdminItemFragment = { __typename?: 'Item', id: string, itemCode: number, name: string, isSelection: boolean, specifications?: string | null | undefined, materialCodePrefix?: string | null | undefined, costCode: { __typename?: 'CostCode', id: string, number: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, cutoff?: { __typename?: 'Cutoff', id: string, name: string } | null | undefined, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string }>, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }, takeoffType?: { __typename?: 'ItemTakeoffTypeDetail', code: Types.ItemTakeoffType, name: string } | null | undefined, optionPricingConfig?: { __typename?: 'OptionPricingConfig', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'OptionPricingConfigVariant', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents?: number | null | undefined, reasonNote?: string | null | undefined, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }> } | null | undefined, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined };

export type SaveItemMutationVariables = Types.Exact<{
  input: Types.SaveItemInput;
}>;


export type SaveItemMutation = { __typename?: 'Mutation', saveItems: Array<{ __typename?: 'Item', id: string, name: string, isSelection: boolean, specifications?: string | null | undefined, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }, takeoffType?: { __typename?: 'ItemTakeoffTypeDetail', code: Types.ItemTakeoffType, name: string } | null | undefined, optionPricingConfig?: { __typename?: 'OptionPricingConfig', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'OptionPricingConfigVariant', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents?: number | null | undefined, reasonNote?: string | null | undefined, projects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }> } | null | undefined, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined }> };

export const AdminItemFragmentDoc = gql`
    fragment AdminItem on Item {
  id
  itemCode
  name
  isSelection
  specifications
  materialCodePrefix
  costCode {
    id
    number
    name
  }
  unitOfMeasure {
    id
    name
  }
  cutoff {
    id
    name
  }
  materialAttributeDimensions {
    id
  }
  designPackageLocation {
    code
    name
  }
  takeoffType {
    code
    name
  }
  optionPricingConfig {
    ...BoundOptionPricingConfigFields_OptionPricingConfig
  }
  materialLeadTimeConfig {
    ...BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfig
  }
}
    ${BoundOptionPricingConfigFields_OptionPricingConfigFragmentDoc}
${BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc}`;
export const ItemsPageMetadataDocument = gql`
    query ItemsPageMetadata {
  costCodes(filter: {version: [1, 2]}) {
    id
    displayName
    version
  }
}
    `;

/**
 * __useItemsPageMetadataQuery__
 *
 * To run a query within a React component, call `useItemsPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsPageMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemsPageMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>(ItemsPageMetadataDocument, options);
      }
export function useItemsPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>(ItemsPageMetadataDocument, options);
        }
// @ts-ignore
export function useItemsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>;
export function useItemsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemsPageMetadataQuery | undefined, ItemsPageMetadataQueryVariables>;
export function useItemsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>(ItemsPageMetadataDocument, options);
        }
export type ItemsPageMetadataQueryHookResult = ReturnType<typeof useItemsPageMetadataQuery>;
export type ItemsPageMetadataLazyQueryHookResult = ReturnType<typeof useItemsPageMetadataLazyQuery>;
export type ItemsPageMetadataSuspenseQueryHookResult = ReturnType<typeof useItemsPageMetadataSuspenseQuery>;
export type ItemsPageMetadataQueryResult = Apollo.QueryResult<ItemsPageMetadataQuery, ItemsPageMetadataQueryVariables>;
export const ItemsDocument = gql`
    query Items($filter: ItemFilter!) {
  items(filter: $filter) {
    ...AdminItem
  }
  unitsOfMeasure {
    id
    name
  }
}
    ${AdminItemFragmentDoc}`;

/**
 * __useItemsQuery__
 *
 * To run a query within a React component, call `useItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemsQuery, ItemsQueryVariables> & ({ variables: ItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
      }
export function useItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
        }
// @ts-ignore
export function useItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemsQuery, ItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemsQuery, ItemsQueryVariables>;
export function useItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemsQuery, ItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemsQuery | undefined, ItemsQueryVariables>;
export function useItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
        }
export type ItemsQueryHookResult = ReturnType<typeof useItemsQuery>;
export type ItemsLazyQueryHookResult = ReturnType<typeof useItemsLazyQuery>;
export type ItemsSuspenseQueryHookResult = ReturnType<typeof useItemsSuspenseQuery>;
export type ItemsQueryResult = Apollo.QueryResult<ItemsQuery, ItemsQueryVariables>;
export const SaveItemDocument = gql`
    mutation SaveItem($input: SaveItemInput!) {
  saveItems(input: {items: [$input]}) {
    id
    name
    isSelection
    specifications
    designPackageLocation {
      code
      name
    }
    takeoffType {
      code
      name
    }
    optionPricingConfig {
      ...BoundOptionPricingConfigFields_OptionPricingConfig
    }
    materialLeadTimeConfig {
      ...BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfig
    }
  }
}
    ${BoundOptionPricingConfigFields_OptionPricingConfigFragmentDoc}
${BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc}`;
export type SaveItemMutationFn = Apollo.MutationFunction<SaveItemMutation, SaveItemMutationVariables>;

/**
 * __useSaveItemMutation__
 *
 * To run a mutation, you first call `useSaveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemMutation, { data, loading, error }] = useSaveItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveItemMutation, SaveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveItemMutation, SaveItemMutationVariables>(SaveItemDocument, options);
      }
export type SaveItemMutationHookResult = ReturnType<typeof useSaveItemMutation>;
export type SaveItemMutationResult = Apollo.MutationResult<SaveItemMutation>;
export type SaveItemMutationOptions = Apollo.BaseMutationOptions<SaveItemMutation, SaveItemMutationVariables>;